import { Controller } from '@hotwired/stimulus';
import { jquery } from 'utils/jquery';

export default class extends Controller {
  public clickRemoveButton(event: Event) {
    event.preventDefault();

    const $ = jquery();
    if (!$) {
      return;
    }

    $('#election_vote_box_id').val('');
  }
}
